import React from 'react';

import {FormControlLabel, Radio, RadioGroup, Typography} from '@material-ui/core';
import {PositionType} from 'commons/types/Types';
import {EfeCatalogValue} from 'commons/models';
import {Utils} from 'commons';
import EfeHelpIcon from 'components/efe-help-icon/EfeHelpIcon';

type Props = {
    label: string;
    fieldName: string;
    disabled?: boolean;
    inlineRadio?: boolean;
    value: string | boolean;
    labelPlacement: PositionType;
    options: Array<EfeCatalogValue>;
    radioLabelPlacement?: PositionType;
    helpIcontext?: string;
    change: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

export default function EfeRadioGroup(props: Props) {
    const {
        label,
        fieldName,
        options,
        disabled,
        value,
        inlineRadio,
        labelPlacement,
        radioLabelPlacement,
        change,
        helpIcontext,
        ...other
    } = props;

    return (
        <FormControlLabel
            style={{alignItems: 'start', margin: 0}}
            {...other}
            control={
                <RadioGroup row={inlineRadio} name={fieldName} value={value} onChange={change}>
                    {options.map((option, index) => (
                        <FormControlLabel
                            key={index}
                            value={option.id}
                            control={<Radio color='secondary' />}
                            disabled={disabled}
                            label={
                                <Typography component={'span'} variant='h5'>
                                    {option.value}
                                </Typography>
                            }
                            labelPlacement={radioLabelPlacement ? radioLabelPlacement : 'end'}
                        />
                    ))}
                </RadioGroup>
            }
            label={
                <>
                    <Typography component={'span'} variant='h5'>
                        {label}
                    </Typography>
                    {helpIcontext && (
                        <EfeHelpIcon
                            key={Utils.functions.Generate.uniqueID()}
                            title={helpIcontext}
                        />
                    )}
                </>
            }
            labelPlacement={labelPlacement}
        />
    );
}
